import { ApiError } from "@ando/core/api";
import { getCurrentUser, getSession, saveUserInfo } from "@ando/core/auth";
import { redirect } from "@tanstack/react-router";
import { hasConsoleAccess, markEngineAccess } from "../access";
import { fetchConsoleContext } from "../api/client";

/** Entitlement denial redirects; operational failures remain visible and retryable. */
export async function ensureConsoleAccess(): Promise<void> {
  if (hasConsoleAccess(getSession())) return;
  try {
    await fetchConsoleContext();
    saveUserInfo(await getCurrentUser());
  } catch (error) {
    if (error instanceof ApiError && error.status === 403) {
      throw redirect({ to: "/workspace/conversations" });
    }
    throw error;
  }
  markEngineAccess();
  if (!hasConsoleAccess(getSession())) {
    throw redirect({ to: "/workspace/conversations" });
  }
}
